/**
 * TimeSlotChip - Displays a selected time slot as a removable chip
 * Shows the selected time range with an option to clear the selection
 */

import { CloseIcon } from '@butter/ui/icons';
import { formatMinutesToTime, formatSlotEndTime } from './utils';

export interface TimeSlotChipProps {
  startMinutes: number;
  endMinutes: number;
  onClear: () => void;
}

export function TimeSlotChip({ startMinutes, endMinutes, onClear }: TimeSlotChipProps) {
  return (
    <div
    className="inline-flex items-center gap-2 rounded-full border border-theme-600 bg-bg-tertiary px-4 py-2"
    data-testid="time-slot-chip"
    >
      <span className="text-sm font-medium text-fg-primary">
        {formatMinutesToTime(startMinutes)} - {formatSlotEndTime(endMinutes)}
      </span>
      <button
        type="button"
        onClick={onClear}
        className="inline-flex items-center justify-center rounded-full transition-colors hover:bg-fg-muted/10 focus:outline-none focus:ring-2 focus:ring-theme-600 focus:ring-offset-2"
        aria-label="Clear selected time slot"
      >
        <CloseIcon className="size-3 ml-1 text-fg-primary" />
      </button>
    </div>
  );
}
